/**
 * 为内网应用生成统一登录地址。
 *
 * token 仅用于内网应用，不应复用于应用中心的其他跳转方式。
 */
export function buildInternalAppUrl(domain: string, token: string): string {
  const url = new URL(domain);

  if (!url.pathname.endsWith("/")) {
    url.pathname = `${url.pathname}/`;
  }

  url.searchParams.set("token", token);
  return url.toString();
}

export function openInternalApp(domain: string, token: string): void {
  window.open(
    buildInternalAppUrl(domain, token),
    "_blank",
    "noopener,noreferrer"
  );
}
